import React, { useEffect, useState, useMemo } from 'react';

import { Button, Box, Icon, Paper, TextField, useTheme, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TableFooter, LinearProgress, CircularProgress, Typography, Pagination, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, ClickAwayListener } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import { AlertSnackBar } from '../../shared/components';
import { IndicesCadastro } from '../../shared/components/indices/IndicesCadastro';
import { ConversorDeValorIndice } from '../../shared/components/indices/ConversorDeValorIndice';
import { CampoTextoMascarado } from '../../shared/components/campo-texto-mascarado/CampoTextoMascarado';


import { useNavigate, useSearchParams } from "react-router-dom"
import jwt_decode from "jwt-decode";


import { Consulta_Caixa_Service, IIndice_Caixa, IListagemCaixas } from '../../shared/services/api/caixa/Consulta_Caixa_Service';
import { LayoutBaseDePagina } from "../../shared/layouts"
import { AutoCompleteDeSetor } from '../../shared/components/autocompletes/AutoCompleteDeSetor';
import { IListagemTipo } from '../../shared/services/api/tipo/TipoService';
import { CaixaService } from '../../shared/services/api/caixa/CaixaService';
// import { AlertSnackBar } from '../../shared/components';
import { Environment } from '../../shared/environment';
import { IUnidade } from '../../shared/services/api/unidade/UnidadeService';
import { IPaginacao } from '../../shared/services/api/axios-config';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';

import { useAppThemeContext } from '../../shared/contexts';
import { ITipo_Indice_Documento, Tipo_Indice_Service } from '../../shared/services/api/tipo_indice/Tipo_Indice_Service';
import { ListagemTipos } from '../../shared/components/dialog/tipos/ListagemTipos';

export const ConsultaDeCaixa: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const { themeName } = useAppThemeContext();

  const [isLoading, setIsLoading] = useState(false);

  const [idSetor, setIdSetor] = useState<number | undefined>(undefined);
  useEffect(() => { setIdSetor(Number(localStorage.getItem("idSetor"))) }, []);


  const [escolha, setEscolha] = useState("");
  const [unidade, setUnidade] = useState<IUnidade>();
  const [caixas, setCaixas] = useState<IListagemCaixas[]>();
  const [caixa, setCaixa] = useState<IListagemCaixas>();
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 1,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  function LimparTabela() {
    setUnidade(undefined)
    setCaixas(undefined);
    setCaixa(undefined);
    resetPaginacao();
  }

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.background.paper,
      color: themeName === "light" ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
      maxWidth: 220,
      border: '1px solid #dadde9',
    },
  }));

  const [tipoMascara, setTipoMascara] = useState("aa9-999-a-999");
  const [showTooltipMascara, setShowTooltipMascara] = useState(false);

  const handleTooltipMascaraClose = () => {
    setShowTooltipMascara(false);
  };

  const handleTooltipMascaraOpen = () => {
    setShowTooltipMascara(true);
  };

  //-------------------------------------------------------------------------------------  Parte dos tipos -------------------------------------------------------------------------------------
  // const [rowsTipo, setRowsTipo] = useState<IListagemTipo[]>([]);
  // const [isLoadingTipo, setIsLoadingTipo] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedIdTipo, setSelectedIdTipo] = useState<number>(0);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  //-------------------------------------------------------------------------------  Fim da parte dos tipos -------------------------------------------------------------------------------
  const [localizador, setLocalizador] = useState('');
  const [helperTextLocalizador, setHelperTextLocalizador] = useState(false);
  const [helperTextIdentificador, setHelperTextIdentificador] = useState(false);
  const [identificador, setIdentificador] = useState("");
  const [helperTextCodBarras, setHelperTextCodBarras] = useState(false);
  const [codBarras, setCodBarras] = useState("");

  const handleChangeLocalizador = (valorMascarado: string) => {
    setLocalizador(valorMascarado.toUpperCase());// colocar todas as letras digitas em maiúsculo
  };

  const handlePesquisarPorIdTipo = (isNewPage: boolean | undefined) => {
    handleClose();
    LimparTabela();
    setIsLoading(true);
    if (isNewPage) {
      Consulta_Caixa_Service.getByIdTipo(selectedIdTipo, pagina, true).then((result) => {// pesquisa todas as caixas com o tipo
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        }
        else {
          setUnidade(result.unidade);
          setCaixas(result.listagemCaixas);
          setPaginacao(result.paginacao);
          setEscolha("tipo");
        }
      });
    } else {
      setSearchParams({ pagina: "1" }, { replace: true })
      Consulta_Caixa_Service.getByIdTipo(selectedIdTipo, 1, true).then((result) => {// pesquisa todas as caixas com o tipo
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        }
        else {
          setUnidade(result.unidade);
          setCaixas(result.listagemCaixas);
          setPaginacao(result.paginacao);
          setEscolha("tipo");
        }
      });
    }

  };

  const handlePesquisarPorSetor = (isNewPage: boolean | undefined) => {
    if (!!idSetor) {
      LimparTabela();
      setIsLoading(true);
      if (isNewPage) {
        Consulta_Caixa_Service.getByIdSetor(idSetor, pagina, true).then((result) => {// pesquisa todas as caixas com o tipo
          setIsLoading(false);
          if (result instanceof Error) {//verificar se deu erro
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
          else {
            setUnidade(result.unidade);
            setCaixas(result.listagemCaixas);
            setPaginacao(result.paginacao);
            setEscolha("setor");
          }
        });
      } else {
        setSearchParams({ pagina: "1" }, { replace: true })
        Consulta_Caixa_Service.getByIdSetor(idSetor, 1, true).then((result) => {// pesquisa todas as caixas com o tipo
          setIsLoading(false);
          if (result instanceof Error) {//verificar se deu erro
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
          else {
            setUnidade(result.unidade);
            setCaixas(result.listagemCaixas);
            setPaginacao(result.paginacao);
            setEscolha("setor");
          }
        });
      }

    }
  }

  const handlePesquisarPorLocalizador = (isNewPage: boolean | undefined) => {
    setSearchParams({ pagina: "1" }, { replace: true })

    if (localStorage.getItem('cnpj') !== undefined && localStorage.getItem('cnpj') !== null) {
      LimparTabela();

      let loc = localizador.replaceAll('-', '').replaceAll('_', '');


      if (loc.length < 10 || (tipoMascara === "aa9-999-aa-999" && loc.length < 11)) {

        setHelperTextLocalizador(true);

      } else {

        LimparTabela();
        setIsLoading(true);

        Consulta_Caixa_Service.getByLocalizador(localizador, localStorage.getItem('cnpj')).then((result) => {// pesquisa todas as caixas com o tipo

          setIsLoading(false);

          if (result instanceof Error) {//verificar se deu erro

            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);

          } else {

            setUnidade(result.unidade);
            setCaixa(result.caixa);
            setEscolha("localizador");

          }

        });

      }

    } else {

      setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione um cliente" });
      setTimeout(() => {
        setAlertSnackbar(undefined);
      }, duracaoAlert);

    }
  }

  useEffect(() => {
    if (escolha === "tipo") {
      handlePesquisarPorIdTipo(true);
    }
    if (escolha === "setor") {
      handlePesquisarPorSetor(true);
    }
    if (escolha === "localizador") {
      handlePesquisarPorLocalizador(true);
    }
    if (escolha === "indice") {
      handlepesquisarPorIndices(true);
    }
  }, [pagina])


  const handleDelete = () => {
    setAbrir(false);
    setIsLoading(true);
    CaixaService.trocarEstado(idToDelete).then(result => {
      setIsLoading(false);
      if (result instanceof Error) {//verificar se deu erro
        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      } else {
        if (escolha !== "localizador" && caixas !== undefined) {
          setCaixas(oldRows => {
            return [
              //@ts-expect-error
              ...oldRows.filter(oldRow => oldRow.idCaixa !== idToDelete),
            ]
          });
        } else if (caixa !== undefined) {
          setCaixa(undefined);
        }
        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Caixa desativada com sucesso" });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      }
    });
  }


  const handleDeleteFiles = () => {
    setAbrirDeleteArquivos(false);
    setIsLoading(true);
    CaixaService.apagarArquivos(idToDelete).then(result => {
      setIsLoading(false);
      if (result instanceof Error) {//verificar se deu erro
        setAlertSnackbar({ tipoAlert: "aviso", mensagem: result.message });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      } else {
        setAlertSnackbar({ tipoAlert: "successo", mensagem: result.message });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);
      }
    });
  }



  function construirTableFooter() {
    if (isLoading) {
      return (
        <TableFooter>
          <TableRow>
            <TableCell colSpan={9}>{/* quantas colunas o loading vai ocupar */}
              <LinearProgress variant='indeterminate' />
            </TableCell>
          </TableRow>
        </TableFooter>
      )
    } else {
      if (escolha === "tipo" || escolha === "setor" || escolha == "indice") {
        if (paginacao.totalCount === 0 && caixa !== undefined) {

          return <caption> {Environment.LISTAGEM_VAZIA} </caption>

        } else if (paginacao?.totalPages > 1) {

          return (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={9} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            </TableFooter>
          )
        }
      } else if (escolha === "localizador") {
        if (caixa === undefined) {
          return <caption> {Environment.LISTAGEM_VAZIA} </caption>
        }
      } else {
        return <caption> Selecione um meio de consulta </caption>
      }
    }
  }

  const [rowsIndice, setRowsIndice] = useState<ITipo_Indice_Documento[]>([]);
  const [valores, setValores] = useState<string[]>([]);
  const [resetIndices, setResetIndices] = useState(false);

  const [isLoadingIndice, setIsLoadingIndice] = useState(false);
  const [openDialogIndice, setOpenDialogIndice] = useState(false);

  const [prevSelectedIdTipo, setPrevSelectedIdTipo] = useState<number>(-1);// inicializar em um valor diferente do tipo selecionado

  // pesquisar os indices de caixa
  const handleClickOpenIndice = () => {
    if (selectedIdTipo !== 0 && selectedIdTipo !== prevSelectedIdTipo) {
      setPrevSelectedIdTipo(selectedIdTipo);
      setRowsIndice([]);
      setValores([]);
      setIsLoadingIndice(true);
      Tipo_Indice_Service.getIndicesCaixaByIdTipo([selectedIdTipo]).then((result) => {
        setIsLoadingIndice(false);

        if (result instanceof Error) {
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          // @ts-expect-error
          setRowsIndice(result);
          setResetIndices(true);
          setTimeout(() => setResetIndices(false), 0);
        }
      });
    }

    setOpenDialogIndice(true);

  }

  const [abrir, setAbrir] = useState(false);
  const [idToDelete, setidToDelete] = useState<number>(0);

  const handleClickDelete = (idCaixa: number) => {
    setAbrir(true);
    setidToDelete(idCaixa);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  const [abrirDeleteArquivos, setAbrirDeleteArquivos] = useState(false);

  const handleClickDeleteFiles = (idCaixa: number) => {
    setAbrirDeleteArquivos(true);
    setidToDelete(idCaixa);
  };

  const handleCancelDeleteFiles = () => {
    setAbrirDeleteArquivos(false);
  };


  interface IPermissoes {
    role: string,
    excluir: boolean
  };

  const [permissoes, setPermissoes] = useState<IPermissoes>({ role: "", excluir: false });

  useEffect(() => {// toda vez que o token for mudado
    const token = localStorage.getItem("ACESS_TOKEN");
    // @ts-expect-error
    var decoded: TJwtToken = jwt_decode(token);
    setPermissoes({ role: decoded.role, excluir: decoded.Excluir });
  }, []);


  const handlePesquisarPorIdentificador = () => {
    if (localStorage.getItem("cnpj") !== null && localStorage.getItem("cnpj") !== undefined && localStorage.getItem("cnpj") !== "") {
      setIsLoading(true);
      LimparTabela();
      Consulta_Caixa_Service.getByIdentificador(identificador, localStorage.getItem("cnpj")).then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          setUnidade(result.unidade);
          setCaixa(result.caixa);
          setEscolha("localizador");
        }
      })
    } else {
      setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione uma unidade" });
      setTimeout(() => {
        setAlertSnackbar(undefined);
      }, duracaoAlert);
    }
  }

  const handlePesquisarPorCodBarras = () => {
    if (localStorage.getItem("cnpj") !== null && localStorage.getItem("cnpj") !== undefined && localStorage.getItem("cnpj") !== "") {
      setIsLoading(true);
      LimparTabela();
      Consulta_Caixa_Service.getByCodBarras(codBarras, localStorage.getItem("cnpj")).then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
        } else {
          setUnidade(result.unidade);
          setCaixa(result.caixa);
          setEscolha("localizador");
        }
      })
    } else {
      setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione uma unidade" });
      setTimeout(() => {
        setAlertSnackbar(undefined);
      }, duracaoAlert);
    }
  }


  const handleCloseIndice = () => {
    setOpenDialogIndice(false);
  };

  const handlepesquisarPorIndices = (isNewPage: boolean | undefined, isReport: boolean | undefined = false) => {
    handleCloseIndice();

    if (valores.every(function (item) { return item === undefined || item === '' || item === 'nenhum' })) {// se nenhum campo foi preenchido
      setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Preencha ao menos um índice" });
      setTimeout(() => {
        setAlertSnackbar(undefined);
      }, duracaoAlert);
    } else {
      setIsLoading(true);
      var dadosIndice: Omit<IIndice_Caixa, 'idCaixa'>[] = ConversorDeValorIndice.explodirParaFiltro(rowsIndice, valores);

      if (!isReport) {
        setCaixas([]);
        if (isNewPage) {
          Consulta_Caixa_Service.getByIndices(selectedIdTipo, dadosIndice, pagina).then(result => {
            setIsLoading(false);
            LimparTabela();
            if (result instanceof Error) {//verificar se deu erro
              setIsLoading(false);
              setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
              setTimeout(() => {
                setAlertSnackbar(undefined);
              }, duracaoAlert);
            }
            else {
              setUnidade(result.unidade);
              setCaixas(result.listagemCaixas);
              setPaginacao(result.paginacao);
              setEscolha("indice");

            }
          });
        } else {
          setSearchParams({ pagina: "1" }, { replace: true })
          Consulta_Caixa_Service.getByIndices(selectedIdTipo, dadosIndice).then(result => {
            setIsLoading(false);
            LimparTabela();
            if (result instanceof Error) {//verificar se deu erro
              setIsLoading(false);
              setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
              setTimeout(() => {
                setAlertSnackbar(undefined);
              }, duracaoAlert);
            }
            else {
              setUnidade(result.unidade);
              setCaixas(result.listagemCaixas);
              setPaginacao(result.paginacao);
              setEscolha("indice");

            }
          });

        }
      }
      else {
        setIsLoading(true);
        Consulta_Caixa_Service.getReportbyIndices(selectedIdTipo, dadosIndice).then(result => {
          setIsLoading(false);
          if (result instanceof Error) {//verificar se deu erro
            setIsLoading(false);
            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);
          }
        });

        setIsLoading(false);
      }
    }
  }

  const [selectedTipo, setSelectedTipo] = useState<IListagemTipo[]>([]);

  const pegarNomeTipo = (rowsTipo: IListagemTipo[], idTipo: number): string => {
    var nome = rowsTipo.find(tipo => tipo.idTipo === idTipo)?.nomeTipo ?? "";

    if (nome === "") {
        for (let i = 0; i < rowsTipo.length; i++) {
        if (rowsTipo[i].tipos) {
            nome = pegarNomeTipo(rowsTipo[i].tipos, idTipo);
            if (nome !== "") {
            break;
            }
        }
        }
    }
    return nome;
  };

  const [abrirIndices, setAbrirIndices] = useState<boolean>(false);

  const exibirTodosIndices = () => {
    setAbrirIndices(!abrirIndices);
  };

      //  useEffect(() => {
      //     // setRowsTipo([]);
      //     setSelectedTipo([]);
      //     setSelectedIdTipo(0);
      //     setRowsIndice([]);
      //     setValores([]);
      // }, [idSetor]);

  return (
    <LayoutBaseDePagina
      titulo="Consultar caixa"
      barraDeFerramentas={
        <>
          <Box
            component={Paper}
            height={theme.spacing(5)}
            marginX={1}
            padding={1}
            paddingX={2}
            display="flex"
            gap={1}
            marginBottom={theme.spacing(1)}
            alignItems="center"
          >
            <AutoCompleteDeSetor selectedIdSetor={selectedIdSetor => setIdSetor(selectedIdSetor)} />
            <Button variant="contained" onClick={() => handlePesquisarPorSetor(false)} disabled={isLoading || !idSetor}>
              <Typography variant='button' noWrap> Pesquisar por setor  </Typography>
            </Button>
            <Button variant="contained" onClick={handleClickOpen} disabled={isLoading /*|| selectedIdTipo === 0 */|| !idSetor}>
              <Typography variant='button' noWrap> Mostrar tipos  </Typography>
            </Button>
            {!!idSetor && !!selectedIdTipo && !!pegarNomeTipo(selectedTipo, selectedIdTipo) &&
              <>

                <Button variant="contained" onClick={handleClickOpenIndice} disabled={isLoading /*|| valores.length === 0*/}>
                  <Typography variant='button' noWrap> Índices </Typography>
                </Button>

                <Typography> Tipo Selecionado: <b> {pegarNomeTipo(selectedTipo, selectedIdTipo)} </b> </Typography>

              </>
            }


            {caixas !== undefined && caixas?.length > 0 && escolha === "indice" &&
              <Box flex={1} display="flex" justifyContent="end">
                <Button variant="contained" onClick={() => {
                  // if(escolha === "tipo")
                  // {
                  //   handlePesquisarPorIdTipo(false);
                  // }
                  // else if(escolha === "setor")
                  // {
                  //   handlePesquisarPorSetor(false);
                  // }
                  // else if(escolha === "indice")
                  // {
                  handlepesquisarPorIndices(false, true);
                  // }
                  // else if(escolha === "localizador")
                  // {
                  //   handlePesquisarPorLocalizador(false);
                  // }
                  // setIsLoading(true); 
                  // setTimeout(() => {setIsLoading(false)},1000); 
                }}>
                  <Typography variant='button' noWrap> Relatório da pesquisa </Typography>
                </Button>
              </Box>
            }

          </Box>

          <Box
            component={Paper}
            height={theme.spacing(5)}
            marginX={1}
            padding={1}
            paddingX={2}
            display="flex"
            gap={1}
            alignItems="center"
          >
            <CampoTextoMascarado
              size="small"
              mask={tipoMascara}
              label="Localizador"
              placeholder="Digite o localizador..."
              disabled={isLoading}
              error={helperTextLocalizador}
              value={localizador}
              onChange={(valorMascarado) => handleChangeLocalizador(valorMascarado)}
              onKeyDown={() => setHelperTextLocalizador(false)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handlePesquisarPorLocalizador(false);
                  e.preventDefault();
                }
              }}
              InputProps={{
                endAdornment:
                  <>
                    <ClickAwayListener onClickAway={handleTooltipMascaraClose}>
                      <div>

                        <HtmlTooltip PopperProps={{ disablePortal: true, }} onClose={handleTooltipMascaraClose} open={showTooltipMascara} disableFocusListener disableHoverListener disableTouchListener arrow title={
                          <React.Fragment>

                            <FormControl>

                              <FormLabel> Tipo de Localizador </FormLabel>

                              <RadioGroup
                                row
                                value={tipoMascara}
                                onChange={(event) => {

                                  setLocalizador('');
                                  setTipoMascara(event.target.value);

                                  setTimeout(() => {

                                    handleTooltipMascaraClose();

                                  }, 500);

                                }}
                              >

                                <FormControlLabel value="aa9-999-a-999" control={<Radio />} label="aa9-999-a-999" />
                                <FormControlLabel value="aa9-999-aa-999" control={<Radio />} label="aa9-999-aa-999" />

                              </RadioGroup>

                            </FormControl>

                          </React.Fragment>
                        }>

                          <IconButton
                            edge="end"
                            onClick={handleTooltipMascaraOpen}
                          >
                            <Icon color='primary'>settings</Icon>
                          </IconButton>

                        </HtmlTooltip>

                      </div>
                    </ClickAwayListener>

                    <IconButton
                      onClick={() => handlePesquisarPorLocalizador(false)}
                      edge="end"
                    >
                      <Icon color={helperTextLocalizador ? 'error' : 'primary'}>search</Icon>
                    </IconButton>

                  </>

              }}
            />

            <Dialog
              open={openDialogIndice}
              onClose={handleCloseIndice}
              fullWidth
              maxWidth={'md'}
            >
              <DialogTitle> Índices </DialogTitle>
              <DialogContent dividers>
                {isLoadingIndice ? (
                  <Box display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress />
                  </Box>
                ) : (
                  <Box>
                    <IndicesCadastro
                      rowsAlterarValorIndice={rowsIndice}
                      onValoresAlterarChange={setValores}
                      reset={resetIndices}
                      comOpcaoNenhumEmRadioESelect
                      aoSalvar={() => handlepesquisarPorIndices(false)}
                    />
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Box
                  width="100%"
                  marginX={1}
                  padding={1}
                  paddingX={2}
                  gap={1}
                  display="flex"
                  justifyContent="center"
                >
                  <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleCloseIndice}>
                    <Typography variant='button' noWrap>Fechar </Typography>
                  </Button>
                  <Button variant="contained" startIcon={<Icon>search</Icon>} onClick={() => handlepesquisarPorIndices(false)} disabled={isLoading}>
                    <Typography variant='button' noWrap> Consultar por índices </Typography>
                  </Button>
                </Box>
              </DialogActions>
            </Dialog>

            <TextField size="small" label="Identificador" placeholder="Digite o Identificador..." error={helperTextIdentificador}
              disabled={isLoading}
              onChange={(event) => setIdentificador(event.target.value)}
              onKeyDown={() => setHelperTextIdentificador(false)}

              onKeyPress={(e) => {
                if (identificador === "") {
                  setHelperTextIdentificador(true);
                }
                else if (e.key === 'Enter') {
                  handlePesquisarPorIdentificador();
                  e.preventDefault();
                }
              }}
              InputProps={{
                endAdornment:
                  <IconButton
                    onClick={() => { if (identificador !== "") { handlePesquisarPorIdentificador() } else { setHelperTextIdentificador(true) } }}
                    edge="end"
                  >
                    <Icon color='primary'>search</Icon>
                  </IconButton>
              }}
            />

            <TextField size="small" label="Código de barras" placeholder="Digite o Código..." type="number" error={helperTextCodBarras}
              disabled={isLoading}
              onChange={(event) => setCodBarras(event.target.value)}

              onKeyDown={(e) => {
                setHelperTextCodBarras(false);

                if (codBarras === "") {
                  setHelperTextCodBarras(true);
                }
                else if (e.key === 'Enter') {
                  handlePesquisarPorCodBarras();
                  e.preventDefault();
                }
              }}
              InputProps={{
                endAdornment:
                  <IconButton
                    onClick={() => { if (codBarras !== "") { handlePesquisarPorCodBarras() } else { setHelperTextCodBarras(true) } }}
                    edge="end"
                  >
                    <Icon color='primary'>search</Icon>
                  </IconButton>
              }}
            />



            {alertSnackbar !== undefined && (
              <>
                {alertSnackbar.tipoAlert === "sucesso" && (
                  <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                )}
                {alertSnackbar.tipoAlert === "erro" && (
                  <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                )}
                {alertSnackbar.tipoAlert === "aviso" && (
                  <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                )}
              </>
            )}

            <DialogConfirm
              AoConfirmar={handleDelete}
              titulo={"Dejesa realmente desativar a caixa?"}
              texto={"Ao confirmar, a caixa e tudo que ela contiver será desativado."}
              abrir={abrir}
              AoCancelar={handleCancel}
            />

            <DialogConfirm
              AoConfirmar={handleDeleteFiles}
              titulo={"Dejesa realmente desativar TODOS os documentos dessa caixa?"}
              texto={"Ao confirmar, tudo que ela contiver será desativado."}
              abrir={abrirDeleteArquivos}
              AoCancelar={handleCancelDeleteFiles}
            />

          </Box>

          <ListagemTipos
              abrir={openDialog}
              setRowsTipo={(rows) => setSelectedTipo(rows)}
              idSetor={idSetor ?? 0}
              indiceCaixa={true}
              AoCancelar={handleClose}
              AoConfirmar={handleClose}
              handleConsultarPorIdTipo={() => handlePesquisarPorIdTipo(false)}
              setIdTipo={(idTipo) => setSelectedIdTipo(idTipo)}
              txtTooltip='Para que um tipo seja listado aqui, é necessário que tenha no mínimo 1 (um) índice de CAIXA'
          />

        </>
      }
    >
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> # </TableCell>
              <TableCell> Localizador </TableCell>
              <TableCell> Identificador </TableCell>
              <TableCell> Código de barras </TableCell>
              <TableCell> Área </TableCell>
              <TableCell> Setor(es) </TableCell>
              <TableCell> Tipo(s) de documento </TableCell>
              <TableCell> Índices  <Button onClick={() => exibirTodosIndices()}> <Icon color={themeName === 'light' ? 'secondary' : 'primary'}> {abrirIndices ? "visibility_off" : "visibility"} </Icon> </Button> </TableCell>
              <TableCell align='center'> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {escolha !== "localizador" ? (

              caixas?.map((caixa, index) => {

                var indices = [""];

                caixa.indice.map((indice) => {
                  if (indice.valor !== "" && indice.valor !== null && indice.valor.trim() !== "-") {
                    indices.push(indice.valor);
                  }

                  else if (indice.dataInicial !== null && indice.dataInicial !== "") {
                    indices.push(indice.dataInicial.split("-").reverse().join("/"));
                  }

                  else if (indice.dataFinal !== null && indice.dataFinal !== "") {
                    indices.push(indice.dataFinal.split("-").reverse().join("/"));
                  }

                  else {
                    indices.push("");
                  }
                })

                return (
                  <TableRow key={caixa.idCaixa}>
                    <TableCell> {((Number(pagina) - 1) * Environment.LIMITE_DE_LINHAS) + (index + 1)} </TableCell>
                    <TableCell> {caixa.localizador} </TableCell>
                    <TableCell> {caixa.identificador} </TableCell>
                    {/* {caixa.observacao !== null && caixa.observacao !== undefined && caixa.observacao.includes("\n") ? (
                      <TableCell>
                        <HtmlTooltip arrow title={
                          <React.Fragment>

                            {caixa.observacao.split("\n").map(linha => {
                              if (linha !== "") {
                                return (<p>{linha}</p>)
                              } else {
                                return (<br />)
                              }
                            })}

                          </React.Fragment>
                        }>
                          <Icon> more_horizon </Icon>
                        </HtmlTooltip>
                      </TableCell>
                    ) : (
                      <TableCell> {caixa.observacao} </TableCell>
                    )} */}
                    <TableCell> {caixa.codigoBarras} </TableCell>
                    <TableCell> {unidade?.nomeUnidade} </TableCell>

                    {caixa.nomeSetor.length <= 2 ? (
                      <TableCell> {caixa.nomeSetor.map((setor, index) => {
                        if (index === caixa.nomeSetor.length - 1) {

                          return setor;
                        } else {

                          return setor + ", ";
                        }
                      })} </TableCell>
                    ) : (
                      <TableCell>
                        <HtmlTooltip arrow title={
                          <React.Fragment>
                            <>{caixa.nomeSetor.map(setor => {
                              return (<>
                                <p key={`${setor}-${index}-ToolTip-Setores"`}>{setor}</p>
                              </>);
                            })}</>
                          </React.Fragment>
                        }>
                          <Icon> more_horizon </Icon>
                        </HtmlTooltip>
                      </TableCell>
                    )}

                    {caixa.nomeTipo.length <= 2 ? (
                      <TableCell> {caixa.nomeTipo.map((tipo, index) => {
                        if (index === caixa.nomeTipo.length - 1) {

                          return tipo;
                        } else {

                          return tipo + ", ";
                        }
                      })} </TableCell>
                    ) : (
                      <TableCell>
                        <HtmlTooltip arrow title={
                          <React.Fragment>
                            <>{caixa.nomeTipo.map(tipo => {
                              return (<>
                                <p key={`${tipo}-${index}-ToolTip-Tipos`}>{tipo}</p>
                              </>);
                            })}</>
                          </React.Fragment>
                        }>
                          <Icon> more_horizon </Icon>
                        </HtmlTooltip>
                      </TableCell>
                    )}


                    {abrirIndices ?
                      (
                        <TableCell key="indices" align='center'>
                          <React.Fragment key="indices-fragment">
                            {indices.map((indice, index) => {
                              return (
                                <React.Fragment key={`${indice}-${index}-ToolTip-indice-fragment`}>
                                  <p key={`${indice}-${index}-ToolTip-indice`}>{indice}</p>
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        </TableCell>
                      ) : (
                        <TableCell key="indices-tooltip" align='center'>
                          <HtmlTooltip key="indices-tooltip-html" arrow title=
                            {
                              <React.Fragment key="indices-tooltip-fragment">
                                {indices.map((indice, index) => {
                                  return (
                                    <React.Fragment key={`${indice}-${index}-ToolTip-indice-fragment`}>
                                      <p key={`${indice}-${index}-ToolTip-indice`}>{indice}</p>
                                    </React.Fragment>
                                  );
                                })}
                              </React.Fragment>
                            }>
                            <Icon key="indices-tooltip-icon"> more_horizon </Icon>
                          </HtmlTooltip>
                        </TableCell>
                      )
                    }

                    <TableCell align='center'>

                      <IconButton size="small" onClick={() => {
                        if ((caixa.localizador === "" || !caixa.localizador) && (caixa.codigoBarras === "" || !caixa.codigoBarras)) {

                          setAlertSnackbar({ tipoAlert: "aviso", mensagem: "A caixa ainda não possui localizador e/ou código de barras" });
                          setTimeout(() => {
                            setAlertSnackbar(undefined);
                          }, duracaoAlert);


                        } 
                        else 
                        {
                          caixa.localizador = caixa.localizador || "null";
                          caixa.codigoBarras = caixa.codigoBarras || "null";
                          navigate(`/documento/indexar/${caixa.idCaixa}/${caixa.localizador}/${caixa.codigoBarras}`) 
                        }

                      }}>
                        <Tooltip arrow title="Indexar documento na caixa">
                          <Icon> note_add </Icon>
                        </Tooltip>
                      </IconButton>

                      <IconButton size="small" onClick={() => {
                        if ((caixa.localizador === "" || !caixa.localizador) && (caixa.codigoBarras === "" || !caixa.codigoBarras)) {

                          setAlertSnackbar({ tipoAlert: "aviso", mensagem: "A caixa ainda não possui localizador e/ou código de barras" });
                          setTimeout(() => {
                            setAlertSnackbar(undefined);
                          }, duracaoAlert);


                        } else { navigate(`/documento/indices/${caixa.idCaixa}`) }

                      }}>
                        <Tooltip arrow title="Indexar documento da caixa">
                          <Icon> document_scanner </Icon>
                        </Tooltip>
                      </IconButton>

                      {/* <IconButton size="small" onClick={() => window.open(`caixa/detalhe/${caixa.idCaixa}`, "_blank")}> */}
                      <IconButton size="small" onClick={() => window.open(`caixa/detalhe/${caixa.idCaixa}`, "_blank")}>
                        <Tooltip arrow title="Editar caixa">
                          <Icon> edit </Icon>
                        </Tooltip>
                      </IconButton>

                      {(permissoes.excluir || permissoes.role === "master" || permissoes.role === "clienteGestor") && (
                        <IconButton size="small" onClick={() => handleClickDelete(caixa.idCaixa)}>
                          <Tooltip arrow title="Apagar caixa">
                            <Icon> delete </Icon>
                          </Tooltip>
                        </IconButton>
                      )}

                      {(permissoes.role === "master") && (
                        <IconButton size="small" onClick={() => handleClickDeleteFiles(caixa.idCaixa)}>
                          <Tooltip arrow title="Apagar TODOS os DOCUMENTOS da CAIXA">
                            <Icon> folder_delete </Icon>
                          </Tooltip>
                        </IconButton>
                      )}


                    </TableCell>
                  </TableRow>
                )
              })
            ) :
              (
                <>

                  {caixa !== undefined && (
                    <TableRow key={caixa.idCaixa}>
                      <TableCell> 1 </TableCell>
                      <TableCell> {caixa.localizador} </TableCell>
                      <TableCell> {caixa.identificador} </TableCell>
                      <TableCell> {caixa.codigoBarras} </TableCell>
                      <TableCell> {unidade?.nomeUnidade} </TableCell>

                      {caixa.nomeSetor.length <= 2 ? (
                        <TableCell> {caixa.nomeSetor.map((setor, index) => {
                          if (index === caixa.nomeSetor.length - 1) {

                            return setor;
                          } else {

                            return setor + ", ";
                          }
                        })} </TableCell>
                      ) : (
                        <TableCell>
                          <HtmlTooltip arrow title={
                            <React.Fragment>
                              <>{caixa.nomeSetor.map(setor => {
                                return (<>
                                  <p key={`${setor}-ToolTip-Setores"`}>{setor}</p>
                                </>);
                              })}</>
                            </React.Fragment>
                          }>
                            <Icon> more_horizon </Icon>
                          </HtmlTooltip>
                        </TableCell>
                      )}

                      {caixa.nomeTipo.length <= 2 ? (
                        <TableCell> {caixa.nomeTipo.map((tipo, index) => {
                          if (index === caixa.nomeTipo.length - 1) {

                            return tipo;
                          } else {

                            return tipo + ", ";
                          }
                        })} </TableCell>
                      ) : (
                        <TableCell>
                          <HtmlTooltip arrow title={
                            <React.Fragment>
                              <>{caixa.nomeTipo.map(tipo => {
                                return (<>
                                  <p key={`${tipo}-ToolTip-Tipos`}>{tipo}</p>
                                </>);
                              })}</>
                            </React.Fragment>
                          }>
                            <Icon> more_horizon </Icon>
                          </HtmlTooltip>
                        </TableCell>
                      )}

                      {abrirIndices ?
                        (
                          <TableCell align='center'>
                            <>{caixa.indice.map((indice, index) => {
                              if (index < caixa.indice.length) {
                                if (indice.valor !== "" && indice.valor !== null && indice.valor.trim() !== "-") {
                                  return (<>
                                    <p key={`${indice.valor}-${index}-ToolTip-indice`}>{indice.valor}</p>
                                  </>);
                                }

                                else if (indice.dataInicial !== null && indice.dataInicial !== "") {
                                  return (
                                    <>
                                      <p key={`${indice.dataInicial.split("-").reverse().join("/")}-${index}-ToolTip-indice`}>{indice.dataInicial.split("-").reverse().join("/")}</p>
                                    </>);
                                }

                                else if (indice.dataFinal !== null && indice.dataFinal !== "") {
                                  return (<>
                                    <p key={`${indice.dataFinal.split("-").reverse().join("/")}-${index}-ToolTip-indice`}>{indice.dataFinal.split("-").reverse().join("/")}</p>
                                  </>);
                                }

                                else {
                                  return (<>
                                    <p key={`vazio-${index}-ToolTip-indice`}>{""}</p>
                                  </>);
                                }
                              }

                            })}
                            </>
                          </TableCell>
                        ) : (
                          <TableCell align='center'>
                            <HtmlTooltip arrow title=
                              {
                                <React.Fragment>
                                  <>{caixa.indice.map((indice, index) => {

                                    if (index < caixa.indice.length) {
                                      if (indice.valor !== "" && indice.valor !== null && indice.valor.trim() !== "-") {
                                        return (<>
                                          <p key={`${indice.valor}-${index}-ToolTip-indice`}>{indice.valor}</p>
                                        </>);
                                      }

                                      else if (indice.dataInicial !== null && indice.dataInicial !== "") {
                                        return (
                                          <>
                                            <p key={`${indice.dataInicial.split("-").reverse().join("/")}-${index}-ToolTip-indice`}>{indice.dataInicial.split("-").reverse().join("/")}</p>
                                          </>);
                                      }

                                      else if (indice.dataFinal !== null && indice.dataFinal !== "") {
                                        return (<>
                                          <p key={`${indice.dataFinal.split("-").reverse().join("/")}-${index}-ToolTip-indice`}>{indice.dataFinal.split("-").reverse().join("/")}</p>
                                        </>);
                                      }

                                      else {
                                        return (<>
                                          <p key={`vazio-${index}-ToolTip-indice`}>{""}</p>
                                        </>);
                                      }
                                    }

                                  })}</>
                                </React.Fragment>
                              }>
                              <Icon> more_horizon </Icon>
                            </HtmlTooltip>
                          </TableCell>
                        )
                      }

                      <TableCell align='center'>
                        <IconButton size="small" onClick={() => {
                          if ((caixa.localizador === "" || !caixa.localizador) && (caixa.codigoBarras === "" || !caixa.codigoBarras)) {

                            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "A caixa ainda não possui localizador e/ou código de barras" });
                            setTimeout(() => {
                              setAlertSnackbar(undefined);
                            }, duracaoAlert);
                            

                          } else { 
                            caixa.localizador = caixa.localizador || "null";
                            caixa.codigoBarras = caixa.codigoBarras || "null";
                            navigate(`/documento/indexar/${caixa.idCaixa}/${caixa.localizador}/${caixa.codigoBarras}`) }
                        }}>
                          <Icon> note_add </Icon>
                        </IconButton>

                        <IconButton size="small" onClick={() => {
                          if ((caixa.localizador === "" || !caixa.localizador) && (caixa.codigoBarras === "" || !caixa.codigoBarras)) {

                            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "A caixa ainda não possui localizador e/ou código de barras" });
                            setTimeout(() => {
                              setAlertSnackbar(undefined);
                            }, duracaoAlert);


                          } else { navigate(`/documento/indices/${caixa.idCaixa}`) }

                        }}>
                          <Tooltip arrow title="Indexar documento da caixa">
                            <Icon> document_scanner </Icon>
                          </Tooltip>
                        </IconButton>

                        <IconButton size="small" onClick={() => navigate(`/caixa/detalhe/${caixa.idCaixa}`)}><Icon> edit </Icon></IconButton>

                        {(permissoes.excluir || permissoes.role === "master" || permissoes.role === "clienteGestor") && (
                          <IconButton size="small" onClick={() => handleClickDelete(caixa.idCaixa)}>
                            <Tooltip arrow title="Apagar caixa">
                              <Icon> delete </Icon>
                            </Tooltip>
                          </IconButton>
                        )}

                        {(permissoes.role === "master") && (
                          <IconButton size="small" onClick={() => handleClickDeleteFiles(caixa.idCaixa)}>
                            <Tooltip arrow title="Apagar TODOS os DOCUMENTOS da CAIXA">
                              <Icon> folder_delete </Icon>
                            </Tooltip>
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
          </TableBody>

          {construirTableFooter()}

        </Table>
      </TableContainer>

    </LayoutBaseDePagina>
  )
}